import { Button, Css, ModalBody, ModalFooter, ModalHeader, SelectField, useModal } from "@homebound/beam";
import { useCallback, useState } from "react";

type SelectBidderModalProps = { bidders: { id: string; name: string }[]; onSelect: (bidderId: string) => void };

export function SelectBidderModal(props: SelectBidderModalProps) {
  const { bidders } = props;
  const { closeModal } = useModal();
  const [selectedBidderId, setSelectedBidderId] = useState<string | undefined>(bidders.first?.id);

  const onSelect = useCallback(
    (bidderId: string) => {
      props.onSelect(bidderId);
      closeModal();
    },
    [props, closeModal],
  );
  return (
    <>
      <ModalHeader>Select Bidder</ModalHeader>
      <ModalBody>
        <div css={Css.df.fdc.gap3.$}>
          <span>Pick a bidder to enter a bid for:</span>
          <SelectField value={selectedBidderId} label="Bidder" options={bidders} onSelect={setSelectedBidderId} />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button onClick={closeModal} label="Cancel" variant="quaternary" />
        <Button onClick={() => onSelect(selectedBidderId!)} label="Continue" disabled={!selectedBidderId} />
      </ModalFooter>
    </>
  );
}
